<template>
  <a-upload
    :multiple="false"
    :fileList="fileList"
    :remove="handleRemove"
    :beforeUpload="beforeUpload"
    :custom-request="fileUpload"
  >
    <a-button type="primary" :size="size" :loading="upload.loading">
      <a-icon v-if="!upload.loading" type="upload" /> {{ $t("Choose File") }}
    </a-button>
  </a-upload>
</template>

<script>
import { uploadFile } from "@/api/kyc";
import { displayErrors } from "@/utils";
import { Button, Upload, Icon } from "ant-design-vue";

export default {
  name: "UploadFiles",
  data() {
    return {
      fileList: [],
      upload: {
        file: null,
        loading: false
      }
    };
  },
  props: {
    file: [Array],
    size: [String],
    proofOfIdentity: [String],
    fileType: [String]
  },
  components: {
    [Button.name]: Button,
    [Upload.name]: Upload,
    [Icon.name]: Icon
  },
  computed: {
    // fileList: {
    //   get() {
    //     return this.fileListArray;
    //   },
    //   set(val) {
    //     this.$emit("update:fileListArray", val);
    //   }
    // }
  },
  watch: {
    file: {
      handler(val) {
        this.fileList = [...val];
      },
      immediate: true
    }
  },
  created() {},
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      // this.fileList = newFileList;
      this.$emit("update:file", newFileList);
    },
    beforeUpload(file) {
      if (this.proofOfIdentity && file.type === "application/pdf") {
        Notification.error({
          message: "Error",
          description: this.$t("PDF TIPS"),
          placement: "bottomRight"
        });
        return false;
      }
      this.upload.file = file;
      // let fileList = [...this.fileList, file];
      // fileList = fileList.slice(-1);
      // this.fileList = fileList;
      // this.$emit("update:fileListArray", fileList);
      return true;
    },
    fileUpload() {
      const { file } = this.upload;
      this.upload.loading = true;
      if (file) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          formData.append("file_type", this.fileType);
          uploadFile(formData)
            .then(res => {
              if (
                res.hasOwnProperty("message") &&
                !res.hasOwnProperty("errors")
              ) {
                // this.fileList = [file];
                const { uid, name, status = "done" } = file;
                this.$emit("update:file", [{ ...res.file, uid, name, status }]);
              } else if (res.hasOwnProperty("errors")) {
                this.$awn.alert(JSON.stringify(res.errors));
              }
              this.upload.loading = false;
            })
            .catch(err => {
              this.upload.loading = false;
              displayErrors(err);
            });
        } catch (err) {
          this.upload.loading = false;
          displayErrors(err);
        }
      }
    }
  }
};
</script>

<style scoped></style>
